import React, { useState, useEffect } from 'react'
import { Link, Redirect, useParams } from "react-router-dom"
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { host, Host } from '../../App';
import Axios from 'axios'
import './Report.css'


const All_Purchase_Requests = () => {
  var [postList, setPostList] = useState([]);
  var [PoNo, setPoNo] = useState({});
  var [poNo, setpoNo] = useState([]);
  var [Item_Desc, setItem_Desc] = useState("");
  var [Date1, setDate1] = useState(new Date());
  var [Postartdate, setPoStartdate] = useState('2025-01-01');
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  var [Supplier, setSupplier] = useState({});
  var [Vendor, setVendor] = useState({});
  var [Approval, setApproval] = useState("");
  var [Status, setStatus] = useState({});
  var [Part_No, setPart_No] = useState({});
  var [PO_No, setPO_No] = useState({});
  var [Brand, setBrand] = useState("");
  var [Customers, setCustomers] = useState([]);
  var [partNo, setpartNo] = useState([]);
  var [Name, setName] = useState({});
  var [Category_list, setCategory_list] = useState([]);
  var token = (window.localStorage.getItem("acessToken"));
  var Stage = (window.localStorage.getItem("Stage"));
  var Ranked = (window.localStorage.getItem("Rank"));
  var user = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  const [rank, setrank] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [AllColumns, setAllColumns] = useState(false);
  var [del, setdel] = useState("0");
  const [Edit, setEdit] = useState(false);

  const toggleAllColumns = () => {
    setAllColumns(!AllColumns);
  }
  const toggleEdit = () => {
    setEdit(!Edit);
  }
  useEffect(() => {
    if (Ranked === '"Admin"' && Stage === '"2"') {
      setrank(true);
    }
  }, [Ranked]);
  const [data, setData] = useState([]);
  const [alldata, setAllData] = useState([]);
  const queryParams = {
    token: token,
    Start_date: Postartdate,
    End_date: Poenddate,
    Name: JSON.stringify(Name),
    Item_Desc: JSON.stringify(Item_Desc),
    Brand: JSON.stringify(Brand),
    Vendor: JSON.stringify(Vendor),
    Approval: JSON.stringify(Approval),
    Part_No: JSON.stringify(Part_No),
    PO_No: JSON.stringify(PO_No),
    Supplier: JSON.stringify(Supplier),
    Status: JSON.stringify(Status)
  };

  //var token = sessionStorage.getItem("token");
  useEffect(() => {
    Axios.get(`https://` + Host + `/Purchase_Requisitions/alldata`, { params: queryParams })
      .then((data) => {
        setAllData(data.data);
      })
  }, []);
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/All_Purchase_Requests/search`, { params: queryParams }).then((data) => {
      setData(data.data);
    })
  }, [Postartdate, Poenddate, Supplier, Brand, Vendor, Name, Item_Desc, Stage, Approval, Part_No, PO_No, del]);
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/All_Purchase_Requests/PONO`, { params: queryParams }).then((data) => {
      setpoNo(data.data);
      console.log(data.data);
    })
  }, []);
  const search = () => {

  }

  const [changedRows, setChangedRows] = useState(new Set());
  const print = () => {
    const changedData = [...changedRows].map(index => {
      return data[index];
    });
    console.log(JSON.stringify(changedData));
  }
  const Approve = (ID) => {
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/approve/${ID},${user},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
  };
  const Status_Change = (ID, Status) => {
    console.log(Status);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/status/${ID},${user},${Status},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
  };
  const Delete = (ID) => {
    console.log(Status);
    setIsLoading(true);
    Axios.delete(`https://` + Host + `/Purchase_Requisitions/delete/${ID},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px', color: 'red' },

        });
        setdel(del + 1);
      }
      setEdit(false);
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
  };
  const PO_No_Change = (ID, PO_No) => {
    console.log(Status);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/PO_No/${ID},${user},${PO_No},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
  };
  const Completion_dateChange = (ID, Completion_date) => {
    console.log(Status);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/Completion_date/${ID},${user},${Completion_date.slice(0, 10)},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
  };
  const Comment_Change = (ID, Comment) => {
    console.log(Comment);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/Comment/${ID},${user},${Comment},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
    setEdit(false);
  };
  const Required_Before_Change = (ID, Required_Before) => {
    console.log(Required_Before);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/Required_Before/${ID},${user},${Required_Before},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
    setEdit(false);
  };
  const Qty_Change = (ID, Qty) => {
    console.log(Qty);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/Qty/${ID},${user},${Qty},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
    setEdit(false);
  };
  const Vendor_Change = (ID, Vendor) => {
    console.log(Vendor);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/Vendor/${ID},${user},${Vendor},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
    setEdit(false);
  };
  const Brand_Change = (ID, Brand) => {
    console.log(Brand);
    setIsLoading(true);
    Axios.post(`https://` + Host + `/Purchase_Requisitions/Brand/${ID},${user},${Brand},${token}`).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },

        });
        setdel(del + 1);
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
    setIsLoading(false);
    setEdit(false);
  };
  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      'max-width': '800px',
      'max-height': '800px',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modal: {
      position: 'relative',
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '90%',
      maxHeight: '90%',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      zIndex: 1001,
    },
    downloadButton: {
      position: 'absolute',
      top: '10px',
      right: '45px',
      fontSize: '24px',
      cursor: 'pointer',
      zIndex: 1002,
    },
    downloadLink: {
      color: 'black',
      textDecoration: 'none',
    },
    closeButton: {
      position: 'absolute',
      top: '10px',
      right: '15px',
      fontSize: '24px',
      cursor: 'pointer',
      zIndex: 1002,
    },
  };
  return (
    <div className="MainPage_data">
      <div class="Container">
        <ToastContainer />
        <div class="row">
          <div class="col">
            <div class="row">
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Requested By' list="category" onChange={(e) => {
                setName((e.target.value).replace(/[{""}]/g, ""))
              }} onSelect={search} />
              <datalist id="category">
                <option></option>
                {[...new Set(alldata.map(x => x.Name))].map((name, index) => (
                  <option key={index}>{name}</option>
                ))}
              </datalist>
            </div>

          </div >
          <div class="col">
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Brand' list='Brand' onChange={(e) => {
                setBrand(e.target.value)
              }} onSelect={search} />
              <datalist id="Brand">
                <option></option>

                {[...new Set(alldata.map(x => x.Brand))].map((Brand, index) => (
                  <option key={index}>{Brand}</option>
                ))}
              </datalist>
            </div>
            <div className='row'>
              {/* Grab the Itemicular Operator name */}
              <input type='text' class="form-control form-rounded" placeholder='Item Description' list="Itemdesc" onChange={(e) => {
                setItem_Desc(e.target.value.replace(/[{"''"}]/g, ''));
              }} onSelect={search} />
              <datalist id="Itemdesc">
                <option></option>
                {[...new Set(alldata.map(x => x.Issue_Description))].map((Issue_Description, index) => (
                  <option key={index}>{Issue_Description}</option>
                ))}
              </datalist>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="col" id='moldng'>
                {/* Grab the Itemicular dates */}
                <input type='date' class="form-control form-rounded" id='supplychain-button' placeholder='Invoice DATE' defaultValue={Postartdate} onChange={(e) => {
                  setPoStartdate(e.target.value)
                }} onSelect={search} />
                <span class="tooltiptext">Filter By Request Date</span>
              </div>

              <div class="col">
                <input type='date' class="form-control form-rounded" id='supplychain-button' placeholder='Operator' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => { setPoEnddate(e.target.value) }} onSelect={search} />
              </div>
            </div>
            <div class="row">
              <div class="col" id="mobileView">
                <button class="btn btn-primary" onClick={toggleEdit}>Edit</button>
              </div>


              <div class="col" id="mobileView">
                <select class="form-control form-rounded" placeholder='Approval' onChange={(e) => {
                  setApproval(e.target.value)
                }} onSelect={search} >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col" id="mobileView">
            <div class="row">
              <div class="col">
                {/* Grab the Itemicular Supplier */}
                <input type='text' class="form-control form-rounded" placeholder='Vendor' list='Vendor' onChange={(e) => {
                  setVendor(e.target.value)
                }} onSelect={search} />
                <datalist id="Vendor">
                  <option></option>
                  {[...new Set(alldata.map(x => x.Vendor))].map((Vendor, index) => (
                    <option key={index}>{Vendor}</option>
                  ))}
                </datalist>
              </div>
              <div class="col">
                {/* Grab the Itemicular Supplier */}
                <input type='text' class="form-control form-rounded" placeholder='Status' list='Status' onChange={(e) => {
                  setStatus(e.target.value)
                }} onSelect={search} />
                <datalist id="Status">
                  <option></option>
                  {[...new Set(alldata.map(x => x.Status))].map((Status, index) => (
                    <option key={index}>{Status}</option>
                  ))}
                </datalist>
              </div>
            </div>
            <div class="row">
              <div class="col">
                {/* Grab the Itemicular Supplier */}
                <input type='text' class="form-control form-rounded" placeholder='Part No' list='Part_No' onChange={(e) => {
                  setPart_No(e.target.value)
                }} onSelect={search} />
                <datalist id="Part_No">
                  <option></option>
                  {[...new Set(alldata.map(x => x.Part_No))].map((Part_No, index) => (
                    <option key={index}>{Part_No}</option>
                  ))}
                </datalist>
              </div>
              <div class="col">
                {/* Grab the Itemicular Supplier */}
                <input type='text' class="form-control form-rounded" placeholder='PO No' list='PO_No' onChange={(e) => {
                  setPO_No(e.target.value)
                }} onSelect={search} />
                <datalist id="PO_No">
                  <option></option>
                  {[...new Set(alldata.map(x => x.PO_No))].map((PO_No, index) => (
                    <option key={index}>{PO_No}</option>
                  ))}
                </datalist>
              </div>
            </div>
          </div>

        </div >
        <br></br>
        <br></br>
        <div id='RRM_table'>
          <table className="table table-hover table-sm">
            <thead>
              <tr>
                <th>Request Date</th>
                <th>Request By</th>
                <th id="mobileView">Part No</th>
                <th >Item Description</th>
                <th id="mobileView">Brand</th>
                <th>PO_Qty</th>
                <th id="mobileView">Unit</th>
                <th id="mobileView">Vendor</th>
                <th id="mobileView">Required Before</th>
                <th>Attachments</th>
                <th >Comments</th>
                <th>Status</th>
                <th id="mobileView">Tentative/Colmpletion Date</th>
                <th>Approval</th>
                {rank ? <th>Approved By</th> : null}
                {rank ? <th>PO_Number</th> : null}
                {rank ? <th>Approve</th> : null}
                {rank && Edit ? <th id="mobileView">Delete</th> : null}
              </tr>
            </thead>
            <tbody>
              {data.map((val, index) => {
                return (
                  <tr key={val.ID} className={`${val.Status === "Pending" ? "lightgrey-background" :
                    val.Status === "Hold" ? "red-background" :
                      val.Status === "Ordered" ? "Yellow-background" :
                        val.Status === "On going" ? "orange-background" :
                          val.Status === 'Completed' ? "green-background" : "white-background"}`}>
                    <td>{val.Requested_Date ? val.Requested_Date.slice(0, 10) : ""}</td>
                    <td>{val.Name}</td>
                    <td id="mobileView">{val.Part_No}</td>
                    <td className="truncate-hover" title={val.Item_Desc || ""}>
                      {(() => {
                        const text = val.Item_Desc || "";
                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                        const parts = text.split(urlRegex);

                        return parts.map((part, idx) => {
                          if (urlRegex.test(part)) {
                            const display = part.length > 30 ? part.slice(0, 30) + "…" : part;
                            return (
                              <a
                                key={idx}
                                href={part}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#007bff",
                                  textDecoration: "underline",
                                  whiteSpace: "nowrap"
                                }}
                              >
                                {display}
                              </a>
                            );
                          }
                          return <span key={idx}>{part}</span>;
                        });
                      })()}
                    </td>


                    {Edit ? <td id="mobileView" >
                      <input type='text'
                        className="form-control form-rounded"
                        defaultValue={val.Brand}
                        title={val.Brand}
                        onBlur={(e) => {
                          Brand_Change(val.ID, e.target.value);
                        }} />
                    </td> : <td id="mobileView">{val.Brand}</td>}

                    {rank && Edit ? <td  >
                      <input type='number'
                        className="form-control form-rounded"
                        defaultValue={val.Qty}
                        title={val.Qty}
                        onBlur={(e) => {
                          Qty_Change(val.ID, e.target.value);
                        }}

                      />
                    </td> : <td>{val.Qty}</td>}
                    <td id="mobileView">{val.Unit}</td>
                    {Edit ? <td id="mobileView" >
                      <input type='text'
                        className="form-control form-rounded"
                        defaultValue={val.Vendor}
                        title={val.Vendor}
                        onBlur={(e) => {
                          Vendor_Change(val.ID, e.target.value);
                        }} />
                    </td> : <td id="mobileView">{val.Vendor}</td>}
                    {rank && Edit ? <td  >
                      <input type='date'
                        className="form-control form-rounded"
                        defaultValue={val.Required_Before.slice(0, 10)}
                        title={val.Required_Before}
                        onBlur={(e) => {
                          Required_Before_Change(val.ID, e.target.value);
                        }}

                      />
                    </td> : <td id="mobileView">{val.Required_Before ? val.Required_Before.slice(0, 10) : ""}</td>}

                    <td>
                      <div id="attachment">
                        {val.File_Link.length > 1 && (() => {
                          let attachments = [];
                          try {
                            attachments = JSON.parse(val.File_Link);
                            if (!Array.isArray(attachments)) {
                              throw new Error("Invalid JSON format");
                            }
                          } catch (error) {
                            console.error("Error parsing File_Link:", error);
                            return null; // Return nothing if JSON is invalid
                          }

                          return attachments.map((attachment, index) => (
                            <div key={index}>
                              <button class="btn btn-secondary"
                                onClick={() => openModal(`${attachment}`)}
                              >
                                Pic {index + 1}
                              </button>
                            </div>
                          ));
                        })()}
                      </div>
                      {selectedImage && (
                        <div style={modalStyles.overlay} onClick={closeModal}>
                          <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
                            <span style={modalStyles.downloadButton}>
                              <a href={selectedImage} download target="_blank" rel="noopener noreferrer" style={modalStyles.downloadLink}>
                                &#128229;
                              </a>
                            </span>
                            <span style={modalStyles.closeButton} onClick={closeModal}>
                              &times;
                            </span>
                            <img
                              src={selectedImage}
                              alt="Attachment Full Size"
                              style={{ maxWidth: '100%', maxHeight: '100%' }}
                            />
                          </div>
                        </div>
                      )}
                    </td>
                    {rank && Edit ? <td  >
                      <input type='text'
                        className="form-control form-rounded"
                        defaultValue={val.Comments}
                        title={val.Comments}
                        onBlur={(e) => {
                          Comment_Change(val.ID, e.target.value);
                        }}
                      />
                    </td> : <td className="truncate-hover">
                      {(() => {
                        const text = val.Comments || "";
                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                        const parts = text.split(urlRegex);
                        return parts.map((part, idx) => {
                          if (urlRegex.test(part)) {
                            // truncate to first 30 chars (or adjust as needed)
                            const display = part.length > 30
                              ? part.slice(0, 30) + "…"
                              : part;
                            return (
                              <a
                                key={idx}
                                href={part}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#007bff", textDecoration: "underline" }}>
                                {display}
                              </a>
                            );
                          }
                          return <span key={idx}>{part}</span>;
                        });
                      })()}
                    </td>}
                    <td>
                      {rank ? (
                        <div className="status-wrapper">
                          <div className="status-text">{val.Status}</div>
                          <select
                            className="form-control form-rounded status-select"
                            defaultValue={val.Status}
                            onBlur={(e) => {
                              Status_Change(val.ID, e.target.value);
                            }}
                            disabled={val.Approval !== "Approved"}
                          >
                            <option value="Submitted">Submitted</option>
                            <option value="Ordered">Ordered</option>
                            <option value="Hold">Hold</option>
                            <option value="Duplicate">Duplicate</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Partially Received">Partially Received</option>
                            <option value="Completed">Completed</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      ) : (
                        val.Status
                      )}
                    </td>
                    {rank ? <td id="mobileView">{val.Completion_Time && val.Status === "Completed" || val.Completion_Time && val.Status === "Ordered" ?
                      <input type="date"
                        className="form-control form-rounded" defaultValue={val.Completion_Time.slice(0, 10)} onBlur={(e) => { Completion_dateChange(val.ID, e.target.value); }} /> : ""}</td> : <td>{val.Completion_Time !== '0000-00-00' ? val.Completion_Time.slice(0, 10) : "N/A"}
                    </td>}
                    <td>{val.Approval}</td>
                    {rank ? <td>{val.Approved_By}</td> : null}
                    {rank ? <td> <input
                      type="text"
                      className="form-control form-rounded" list='poNo' Value={val.PO_No === 0 ? '' : val.PO_No ?? ''} onBlur={(e) => { PO_No_Change(val.ID, e.target.value); }} />

                    </td> : null}
                    {rank ? (
                      <td>
                        {val.Approval === 'Pending' && (
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              window.confirm('Are you sure you want to Approve?') && Approve(val.ID);
                            }}
                          >
                            Approve
                          </button>
                        )}
                      </td>
                    ) : null}
                    {rank && Edit ? <td id="mobileView"> {(val.Approval === 'Approved' || val.Status === "Submitted") ? <button className='btn btn-danger' onClick={() => { window.confirm('Are you sure you want to Delete?') && Delete(val.ID); }}>Delete</button> : null}</td> : null}
                  </tr>

                );
              })}
            </tbody>
          </table>
        </div>
      </div >

      {isLoading ?
        <div className='overlay'>
          <div className="loading-container">
            <div className="loading-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
            <p className='loading'>Loading</p>
          </div>
        </div> : null}
    </div >
  )
}

export default All_Purchase_Requests;